/* 🤖 this file was generated by svg-to-ts */
export const fthrCircle: {
    name: 'fthr-circle';
    data: string;
} = {
    name: 'fthr-circle',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/></svg>`,
};
